import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1.66666C10.2302 1.66666 10.4167 1.8532 10.4167 2.08332L10.4176 3.34825C13.3279 3.55779 15.6251 5.93689 15.7258 8.86215L15.7292 9.06243V12.7333L15.8047 12.7588C16.2366 12.9271 16.5578 13.3097 16.6438 13.7718L16.6614 13.8997L16.6667 14.0208V14.5833C16.6667 15.233 16.171 15.767 15.5371 15.8275L15.4167 15.8333L13.2284 15.8331C12.8584 17.2709 11.5533 18.3333 10 18.3333C8.44677 18.3333 7.14163 17.2709 6.77167 15.8331L4.58337 15.8333C3.93363 15.8333 3.39967 15.3375 3.3391 14.7036L3.33337 14.5833V14.0208C3.33337 13.4725 3.6592 13.0003 4.12777 12.7873L4.23836 12.7429L4.27087 12.7324V9.06243C4.27087 6.03839 6.6138 3.56157 9.58346 3.34817L9.58337 2.08332C9.58337 1.8532 9.76992 1.66666 10 1.66666ZM12.3578 15.8332H7.64227C7.98545 16.8043 8.9115 17.5 10 17.5C11.0886 17.5 12.0146 16.8043 12.3578 15.8332ZM10.1833 4.16988L10.0061 4.16661L9.99187 4.16653C7.35697 4.16697 5.20408 6.26031 5.10758 8.8789L5.10421 9.06243V13.0833C5.10421 13.2878 4.95681 13.4579 4.76244 13.4932L4.61058 13.5056C4.38733 13.5386 4.21025 13.7134 4.17366 13.9354L4.16671 14.0208V14.5833C4.16671 14.7878 4.3141 14.9579 4.50848 14.9932L4.58337 14.9999H15.4167C15.6213 14.9999 15.7914 14.8525 15.8267 14.6582L15.8334 14.5833V14.0208C15.8334 13.7839 15.6743 13.5815 15.4706 13.5208L15.3923 13.5048L15.2901 13.4993C15.0936 13.4887 14.9349 13.3432 14.9021 13.1554L14.8959 13.0833V9.06243C14.8959 6.48681 12.9032 4.36557 10.3696 4.17998L10.1833 4.16988Z"
          fill={color}
        />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C12.2761 2 12.5 2.22386 12.5 2.5L12.501 4.01791C15.9935 4.26936 18.7501 7.12428 18.8709 10.6346L18.875 10.8749V15.2799L18.9656 15.3106C19.4838 15.5126 19.8693 15.9717 19.9725 16.5262L19.9936 16.6797L20 16.8249V17.4999C20 18.2796 19.4051 18.9204 18.6445 18.9931L18.5 18.9999L15.874 18.9998C15.4301 20.7251 13.8639 22 12 22C10.1361 22 8.56991 20.7251 8.12595 18.9998L5.5 18.9999C4.7203 18.9999 4.07955 18.405 4.00687 17.6444L4 17.4999V16.8249C4 16.167 4.39099 15.6004 4.95328 15.3448L5.08598 15.2915L5.125 15.2789V10.8749C5.125 7.24608 7.93651 4.27389 11.5001 4.01782L11.5 2.5C11.5 2.22386 11.7239 2 12 2ZM14.8293 18.9999H9.17067C9.58249 20.1651 10.6937 21 12 21C13.3063 21 14.4175 20.1651 14.8293 18.9999ZM12.2199 5.00387L12.0072 4.99995L11.9902 4.99985C8.82832 5.00038 6.24485 7.51239 6.12905 10.6547L6.125 10.8749V15.6999C6.125 15.9454 5.94812 16.1495 5.71488 16.1919L5.53264 16.2067C5.26474 16.2464 5.05226 16.4561 5.00834 16.7225L5 16.8249V17.4999C5 17.7454 5.17688 17.9495 5.41012 17.9919L5.5 17.9999H18.5C18.7455 17.9999 18.9496 17.823 18.9919 17.5898L19 17.4999V16.8249C19 16.5407 18.8091 16.2978 18.5646 16.2249L18.4707 16.2058L18.3481 16.1992C18.1123 16.1865 17.9219 16.0118 17.8825 15.7866L17.875 15.6999V10.8749C17.875 7.78418 15.4838 5.23869 12.4434 5.01599L12.2199 5.00387Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'notification');
export default IconComponent;
